import type { CmtsHttpClient } from "../api/cmtsHttpClient.js";
import { CMTS_API } from "../api/cmtsApiPaths.js";
import { mapAuditEvent } from "../mappers/diagnosticMappers.js";
import { repositoryCall } from "./repositoryResult.js";
import { mapCollection } from "./repositoryCollection.js";

export type AuditRepository = ReturnType<typeof createAuditRepository>;

export function createAuditRepository(client: CmtsHttpClient) {
  return {
    logs: (query?: Record<string, string | number | boolean | undefined>) => repositoryCall(async () => mapCollection(await client.get<unknown>(CMTS_API.audit.logs, { query }), mapAuditEvent), "CMTS_AUDIT_LOGS"),
    detail: (id: string, tenantId?: string) => repositoryCall(() => client.get<Record<string, unknown>>(CMTS_API.audit.detail(id), { query: { tenantId } }), "CMTS_AUDIT_DETAIL"),
    exportHistory: (tenantId?: string) => repositoryCall(() => client.get<readonly Record<string, unknown>[]>(CMTS_API.audit.exportHistory, { query: { tenantId } }), "CMTS_AUDIT_EXPORT_HISTORY"),
    exportAudit: (payload: Record<string, unknown>, tenantId?: string) => repositoryCall(() => client.post<Record<string, unknown>>(CMTS_API.audit.exportAudit, payload, { query: { tenantId } }), "CMTS_AUDIT_EXPORT"),
  };
}
